import React from 'react';
import PropTypes from 'prop-types';

import LoadingImage from '../../assets/svgs/LoadingImage';

import { LoadingStyle } from './LoadingStyle';

const Loading = ({ message }) => {
  return (
    <LoadingStyle>
      <div className="loading-message-container">
        <div className="loading-image-wrapper">
          <LoadingImage />
        </div>
        {message && message.length ? (
          <div className="loading-message-wrapper">{message}</div>
        ) : null}
      </div>
    </LoadingStyle>
  );
};

Loading.propTypes = {
  message: PropTypes.string,
};

Loading.defaultProps = {
  message: '',
};

export default Loading;
